import { useContext } from 'react';
import { WorkspaceFileStateContext } from '../Context';

export const useWorkspaceFileState = () => {
  const state = useContext(WorkspaceFileStateContext);

  return state;
};

export default useWorkspaceFileState;